module.exports = __webpack_public_path__ + "static/media/hotdog.18c5e3a0.svg";